import React from 'react';
import {Prelead} from 'api';
import {Row} from 'react-table';

interface Props {
  row: Row<Prelead>;
}

const ClickCell = ({row}: Props) => {
  const prelead: Prelead = row.original;

  return <>{prelead.clickCount}</>;
};

export default ClickCell;
